import { css } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'

import Button from '../../input/Button'
import { useCategoryTree } from '../CategoryTree.query'

interface Props {
    id: number
}

const FilterUl = styled.ul`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    list-style: none;
    margin: 0 auto 20px;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow-x: scroll;
    scrollbar-width: none;
    user-select: none;
    gap: 15px;

    &::-webkit-scrollbar {
        display: none;
    }

    @media screen and (min-width: 1025px) {
        flex-wrap: wrap;
    }
`

const FilterLi = styled.li`
    padding: 0;
    margin: 0;
    user-select: none;

    &:first-of-type {
        margin-left: 0;
    }
`

const Wrapper = styled.div`
    position: relative;
    display: flex;
`

const TextFilter = ({ id }: Props) => {
    let categoryData

    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data } = useCategoryTree(id)

        categoryData = data
    } catch {
        return null
    }

    if (
        !categoryData ||
        !categoryData.category ||
        categoryData.category.level !== 2 ||
        categoryData.category.children.length < 2
    ) {
        return null
    }

    const sortedCategories = [...categoryData.category.children]
        .filter((cat) => cat.includeInMenu)
        .sort((a, b) => {
            if (!a || !b || !a.position || !b.position) {
                return 0
            }

            return a.position - b.position
        })

    return (
        <Wrapper>
            <FilterUl
                css={
                    sortedCategories.length <= 2
                        ? css`
                              @media screen and (max-width: 767px) {
                                  justify-content: center;
                              }
                          `
                        : undefined
                }
            >
                {sortedCategories.map(
                    ({ id, name, urlPath }) =>
                        urlPath && (
                            <FilterLi key={id}>
                                <Button
                                    to={`/${urlPath}`}
                                    name={name}
                                    category="categoryFilter"
                                    variant="secondaryAlt"
                                    preload
                                >
                                    {name}
                                </Button>
                            </FilterLi>
                        ),
                )}
            </FilterUl>
        </Wrapper>
    )
}

export default TextFilter
